function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 680 680",
    role: "img",
    style: {},
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(11, 11, 11)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    },
    id: titleId
  }, "BodhAPI logo") : title ? /*#__PURE__*/React.createElement("title", {
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(11, 11, 11)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    },
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("desc", {
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(11, 11, 11)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, "Abstract geometric mark for BodhAPI \u2014 bold, modern, data-flow inspired"), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 140,
    width: 400,
    height: 400,
    rx: 80,
    style: {
      fill: "rgb(10, 10, 15)",
      stroke: "none",
      color: "rgb(11, 11, 11)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340,
    cy: 340,
    r: 130,
    fill: "none",
    stroke: "#6C63FF",
    strokeWidth: 16,
    strokeDasharray: "220 200",
    strokeDashoffset: 0,
    style: {
      fill: "none",
      stroke: "rgb(108, 99, 255)",
      color: "rgb(11, 11, 11)",
      strokeWidth: 16,
      strokeDasharray: "220px, 200px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340,
    cy: 340,
    r: 130,
    fill: "none",
    stroke: "#3ECFCF",
    strokeWidth: 8,
    strokeDasharray: "110 310",
    strokeDashoffset: 110,
    style: {
      fill: "none",
      stroke: "rgb(62, 207, 207)",
      color: "rgb(11, 11, 11)",
      strokeWidth: 8,
      strokeDasharray: "110px, 310px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340,
    cy: 340,
    r: 88,
    fill: "none",
    stroke: "#6C63FF",
    strokeWidth: 1.5,
    opacity: 0.3,
    style: {
      fill: "none",
      stroke: "rgb(108, 99, 255)",
      color: "rgb(11, 11, 11)",
      strokeWidth: "1.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.3,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 252,
    x2: 340,
    y2: 295,
    stroke: "#6C63FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    opacity: 0.6,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(108, 99, 255)",
      color: "rgb(11, 11, 11)",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      opacity: 0.6,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 385,
    x2: 340,
    y2: 428,
    stroke: "#6C63FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    opacity: 0.6,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(108, 99, 255)",
      color: "rgb(11, 11, 11)",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      opacity: 0.6,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 252,
    y1: 340,
    x2: 295,
    y2: 340,
    stroke: "#3ECFCF",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.6,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(62, 207, 207)",
      color: "rgb(11, 11, 11)",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      opacity: 0.6,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 385,
    y1: 340,
    x2: 428,
    y2: 340,
    stroke: "#3ECFCF",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.6,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(62, 207, 207)",
      color: "rgb(11, 11, 11)",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      opacity: 0.6,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 278,
    y1: 278,
    x2: 308,
    y2: 308,
    stroke: "#6C63FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.4,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(108, 99, 255)",
      color: "rgb(11, 11, 11)",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      opacity: 0.4,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 402,
    y1: 278,
    x2: 372,
    y2: 308,
    stroke: "#3ECFCF",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.4,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(62, 207, 207)",
      color: "rgb(11, 11, 11)",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      opacity: 0.4,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 278,
    y1: 402,
    x2: 308,
    y2: 372,
    stroke: "#3ECFCF",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.4,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(62, 207, 207)",
      color: "rgb(11, 11, 11)",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      opacity: 0.4,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 402,
    y1: 402,
    x2: 372,
    y2: 372,
    stroke: "#6C63FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    opacity: 0.4,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(108, 99, 255)",
      color: "rgb(11, 11, 11)",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      opacity: 0.4,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340,
    cy: 340,
    r: 28,
    fill: "#6C63FF",
    style: {
      fill: "rgb(108, 99, 255)",
      stroke: "none",
      color: "rgb(11, 11, 11)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340,
    cy: 340,
    r: 14,
    fill: "#0a0a0f",
    style: {
      fill: "rgb(10, 10, 15)",
      stroke: "none",
      color: "rgb(11, 11, 11)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340,
    cy: 340,
    r: 6,
    fill: "#3ECFCF",
    style: {
      fill: "rgb(62, 207, 207)",
      stroke: "none",
      color: "rgb(11, 11, 11)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340,
    cy: 210,
    r: 10,
    fill: "#6C63FF",
    style: {
      fill: "rgb(108, 99, 255)",
      stroke: "none",
      color: "rgb(11, 11, 11)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340,
    cy: 470,
    r: 10,
    fill: "#6C63FF",
    style: {
      fill: "rgb(108, 99, 255)",
      stroke: "none",
      color: "rgb(11, 11, 11)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 340,
    r: 7,
    fill: "#3ECFCF",
    style: {
      fill: "rgb(62, 207, 207)",
      stroke: "none",
      color: "rgb(11, 11, 11)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 470,
    cy: 340,
    r: 7,
    fill: "#3ECFCF",
    style: {
      fill: "rgb(62, 207, 207)",
      stroke: "none",
      color: "rgb(11, 11, 11)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248,
    cy: 248,
    r: 5,
    fill: "#6C63FF",
    opacity: 0.7,
    style: {
      fill: "rgb(108, 99, 255)",
      stroke: "none",
      color: "rgb(11, 11, 11)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.7,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432,
    cy: 248,
    r: 5,
    fill: "#3ECFCF",
    opacity: 0.7,
    style: {
      fill: "rgb(62, 207, 207)",
      stroke: "none",
      color: "rgb(11, 11, 11)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.7,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248,
    cy: 432,
    r: 5,
    fill: "#3ECFCF",
    opacity: 0.7,
    style: {
      fill: "rgb(62, 207, 207)",
      stroke: "none",
      color: "rgb(11, 11, 11)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.7,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 432,
    cy: 432,
    r: 5,
    fill: "#6C63FF",
    opacity: 0.7,
    style: {
      fill: "rgb(108, 99, 255)",
      stroke: "none",
      color: "rgb(11, 11, 11)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.7,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.82f35175d1b1d861fd6f365fcc9613a4.svg";
export { ForwardRef as ReactComponent };